export const clog = () => {
  console.log = function() {};
};

export const ISCONPPONMA = false;
